import React from "react";
import "./textarea.scss";
import { INPUT_LIMITS } from "../input-limits";

function TextareaInput({ label, value, onChange, className }) {
  const handleTextChange = (e) => {
    onChange(e.target.value);
  };

  if (value === undefined || value === null) {
    value = "";
  }

  return (
    <div>
      {label ? <div className="text-grigora-base mb-2">{label}</div> : null}
      <textarea
        minLength={INPUT_LIMITS["textarea-input"].minlength}
        maxLength={INPUT_LIMITS["textarea-input"].maxlength}
        value={value}
        onChange={handleTextChange}
        rows={5}
        className="grigora-textarea-input__field text-grigora-base resize-none p-2 w-full bg-editor-input-selected rounded-[6px] border-gray-300 border focus-visible:outline-none"
      />
    </div>
  );
}

export default TextareaInput;
